module.exports = __webpack_public_path__ + "static/media/rustskins.4f9e6e49.gif";